import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import { useThemeProps, Section, TypographyBlock } from "@wsui/base";
import FeatureBillboardModule from "./FeatureBillboardModule.mjs";
import { Fragment } from "react";
import EventAttributeList from "./EventAttributeList.mjs";
function EventHero(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "EventHero"
  });
  let {
    occasions,
    attributes,
    imagePlacement = "right",
    renderAttributeValue = value => value,
    ...restProps
  } = props;
  return /* @__PURE__ */jsx(FeatureBillboardModule, {
    imagePlacement,
    breakpoint: 300,
    padding: [7.5, 15],
    contentAlign: "start",
    content: /* @__PURE__ */jsx(Fragment, {
      children: /* @__PURE__ */jsx(Section, {
        children: /* @__PURE__ */jsx(TypographyBlock, {
          children: /* @__PURE__ */jsx(EventAttributeList, {
            occasions,
            attributes,
            renderAttributeValue
          })
        })
      })
    }),
    ...restProps
  });
}
export { EventHero as default };